export { getConnectedAccountHeaders } from './utils/getConnectedAccountHeaders';
export { getConnectedAccountRequestOptions } from './utils/getConnectedAccountRequestOptions';
export { isSharedTypeMailbox } from './utils/getConnectedAccountRequestOptions';
